module.exports = __WEBPACK_EXTERNAL_MODULE_170__;


//////////////////
// WEBPACK FOOTER
// external "copy-paste"
// module id = 170
// module chunks = 0